import customAxios from "../../customHook/customAxios";

import { getAuthHeader } from '../../utils';

export const v3_add_leave_application = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/leave/application`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_edit_leave_application = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/leave/application`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_applied_leaves = async (page, limit, filters = {}) => {
    const params = new URLSearchParams(Object.entries(filters).filter(([, value]) => value));
    const url = `${process.env.REACT_APP_BASE_URL}/v3/leave/applied/${page}/${limit}${params.toString() ? `?${params}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_delete_leave_application = async (leaveId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/leave/application/${leaveId}`;
    return customAxios.delete(url, getAuthHeader()).then((res) => res.data);
}
